import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';

@Component({
  selector: 'mode-auto-update-message',
  templateUrl: './auto-update-message.component.html',
  styleUrls: ['./auto-update-message.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AutoUpdateMessageComponent implements OnChanges {
  @Input() isRendered = false;
  @Output() updateVisualization = new EventEmitter();
  @Output() setToAutomatic = new EventEmitter();

  description = '';

  ngOnChanges(): void {
    this.description = this.isRendered
      ? 'You must apply your changes manually'
      : 'You must load your visualization manually';
  }

  doUpdate() {
    this.updateVisualization.emit();
  }

  doAutomatic() {
    this.setToAutomatic.emit();
  }
}
